import { Layers2 as icon } from "lucide-react"
import create from "./storeys.create"
import edit from "./storeys.edit"

import { StoreyRecord } from "./storeys.types"

const crud = (permissions: Record<string, string[]>) => ({
  name: "storeys",
  options: { label: "Storeys" },
  edit:
    "storeys" in permissions && permissions.storeys.includes("edit")
      ? edit
      : undefined,
  create:
    "storeys" in permissions && permissions.storeys.includes("create")
      ? create
      : undefined,
  icon,

  recordRepresentation: (record: StoreyRecord): string => record.title,
})

export default crud
